export default {
  createTopicFeedbackActionTemplate: '/topicFeedbackActionTemplate/createTopicFeedbackActionTemplate',
  getTopicFeedbackActionTemplatesOfAnInstitute: '/topicFeedbackActionTemplate/getTopicFeedbackActionTemplatesOfAnInstitute',
  getTopicFeedbackActionTemplateById: '/topicFeedbackActionTemplate/getTopicFeedbackActionTemplateById'
}
